import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
//import { syncHistoryWithStore } from 'react-router-redux';


import { Router } from 'react-router-dom';

import createHistory from 'history/createBrowserHistory'

import injectTapEventPlugin from 'react-tap-event-plugin';


import { configureUrlQuery } from 'react-url-query';
import configureStore from "./store/configureStore";

import './index.css';
import App from './App';

import registerServiceWorker from './registerServiceWorker';


injectTapEventPlugin();

const history = createHistory();


const store = configureStore(history);
configureUrlQuery({ history: history });



ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <App />
        </Router >
    </Provider>,
    document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js